import { signal } from "@preact/signals";
import { audioID, videoID } from "./config";

const audioDevices = signal<MediaDeviceInfo[]>([]);
const videoDevices = signal<MediaDeviceInfo[]>([]);

const commonDeviceNames = ["ShadowCast", "Elgato", "USB2 Video", "USB3 Video", "USB2 Audio", "USB3 Audio"];

const isRecommendedDevice = (device: MediaDeviceInfo) => {
    return commonDeviceNames.some((name) => device.label.includes(name));
};

const onNewDevice = async () => {
    const foundAudioDevices: MediaDeviceInfo[] = [];
    const foundVideoDevices: MediaDeviceInfo[] = [];

    const devices = (await navigator.mediaDevices.enumerateDevices()).sort((a, b) => a.label.localeCompare(b.label));
    for (const device of devices) {
        if (device.deviceId === "") {
            continue;
        }

        if (device.kind === "audioinput") {
            foundAudioDevices.push(device);
        }

        if (device.kind === "videoinput") {
            foundVideoDevices.push(device);
        }
    }

    if (!audioID.value) {
        const device = foundAudioDevices.findLast(isRecommendedDevice);
        if (device) {
            audioID.value = device.deviceId;
        }
    }

    if (!videoID.value) {
        const device = foundVideoDevices.findLast(isRecommendedDevice);
        if (device) {
            videoID.value = device.deviceId;
        }
    }

    audioDevices.value = foundAudioDevices;
    videoDevices.value = foundVideoDevices;
};

if (navigator?.mediaDevices) {
    navigator.mediaDevices.addEventListener("devicechange", onNewDevice);
    onNewDevice();
}

onNewDevice();

export { audioDevices, videoDevices, isRecommendedDevice };
